export const KEY_IMPORT_RECIPIENTS_BULK_BATCH_ID =
  "KEY_IMPORT_RECIPIENTS_BULK_BATCH_ID";
